import { useMutation } from '@tanstack/react-query'
import { settingsService } from '../../services'
import type { DuplicateFlexMessagePresetResponse } from '../../../types'

interface UseMutationDuplicateFlexMessagePresetOptions {
	onSuccess?: (data: DuplicateFlexMessagePresetResponse) => void
	onError?: (error: unknown) => void
}

export default function useMutationDuplicateFlexMessagePreset(
	options?: UseMutationDuplicateFlexMessagePresetOptions,
) {
	return useMutation({
		mutationKey: ['duplicate-flex-message-preset'],
		mutationFn: (presetId: string) =>
			settingsService.duplicateFlexMessagePreset(presetId),
		...options,
	})
}
